// =============================================================================
// VINUM - Confirm Dialog Component
// Generic confirmation dialog built on Modal + Button
// =============================================================================

import React from 'react';
import { Modal, ModalBody, ModalFooter } from './Modal';
import { Button, ButtonProps } from './Button';

export interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title: string;
  description?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: ButtonProps['variant'];
  loading?: boolean;
  icon?: React.ReactNode;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = 'Conferma',
  cancelLabel = 'Annulla',
  confirmVariant = 'primary',
  loading = false,
  icon,
}) => {
  return (
    <Modal open={open} onClose={onClose} size="sm" closeOnOverlay={!loading} closeOnEscape={!loading}>
      <ModalBody>
        <div className="flex items-start gap-3">
          {icon && <div className="flex-shrink-0 mt-0.5">{icon}</div>}
          <div className="flex-1 pr-6">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{title}</h2>
            {description && (
              <div className="mt-2 text-sm text-gray-600 dark:text-gray-400">{description}</div>
            )}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="ghost" onClick={onClose} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm} loading={loading}>
          {confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ConfirmDialog.displayName = 'ConfirmDialog';
